import { Spinner } from "react-bootstrap";



const InitalLoadingComponent = () => {


    return (
        <div style={{ height: '80%' }}>
            <Spinner
                animation="border"
                role="status"
                style={{
                    justifyContent: 'center',
                    display: 'flex',
                    top: '50%',
                    left: '50%',
                    position: 'relative',
                    height: '100px',
                    width: '100px'
                }}
            />
        </div>
    )
}


export default InitalLoadingComponent;
